import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import SearchSelect from "../../../components/private/searchselect";

const Minutas = () => {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);

  const [contracts, setContracts] = useState([]);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    minuta: "",
    id_contract: "",
    numero_contrato: "",
    objeto: ""
  });

  // ============================
  //   CARGAR CONTRATOS
  // ============================
  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const response = await fetch(ENDPOINTS.getContract, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const result = await response.json();

        if (result.success && Array.isArray(result.contracts)) {
          setContracts(result.contracts);
        } else {
          setContracts([]);
          setError("No se pudieron cargar los contratos");
        }
      } catch (err) {
        console.error(err);
        setContracts([]);
        setError("Error al conectar con el servidor");
      }
    };

    fetchContracts();
  }, [token]);

  // ============================
  //   HANDLER
  // ============================
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // ============================
  //   GENERAR PDF (PRUEBA)
  // ============================
  const handleGenerate = (e) => {
  e.preventDefault();

  if (!formData.minuta || !formData.id_contract || !formData.numero_contrato) {
    setError("Debe completar todos los campos");
    return;
  }

  let endpoint = "";

  // ============================
  //   SELECCIONAR ENDPOINT
  // ============================
  switch (formData.minuta) {
    case "OBRA_LABOR_HOGARES_SUSTITUTOS":
      endpoint = ENDPOINTS.minutaObraLaborHS;
      break;

    case "OBRA_LABOR_EXTERNADO_JORNADA_COMPLETA":
      endpoint = ENDPOINTS.minutaObraLaborEJC;
      break;

    case "OBRA_LABOR_INSTITUCIONAL":
      endpoint = ENDPOINTS.minutaObraLaborIns;
      break;
    
    case "CONTRATO_FIJO_BUEN_COMIENZO":
      endpoint = ENDPOINTS.minutaContratoFijoBC;
      break;

    case "CONTRATO_FIJO_INSTITUCION_EDUCATIVA":
      endpoint = ENDPOINTS.minutaContratoFijoIE;
      break;

    case "CONTRATO_FIJO_AREA_ADMINISTRATIVA":
      endpoint = ENDPOINTS.minutaContratoFijoAdministrativa;
      break;

    case "CONTRATO_INDEFINIDO_AREA_ADMINISTRATIVA":
      endpoint = ENDPOINTS.minutaContratoIndefinidoAdministrativa;
      break;

    case "CONTRATO_FIJO_HOGARES_SUSTITUTOS":
      endpoint = ENDPOINTS.minutaContratoFijoHS;
      break;

    default:
      setError("Minuta no válida");
      return;
  }


  // ============================
  //   CREAR FORM Y ENVIAR
  // ============================
  const form = document.createElement("form");
  form.method = "POST";
  form.action = endpoint;
  form.target = "_blank";

  const fields = {
    id_contrato: formData.id_contract,
    numero_contrato: formData.numero_contrato
  };

  // Solo enviar objeto si aplica
if (formData.minuta === "OBRA_LABOR_INSTITUCIONAL") {
  fields.objeto = formData.objeto;
}

  Object.entries(fields).forEach(([key, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
const contractOptions = contracts.map((c) => ({
  value: c.id_contrato,
  label: `COD${c.id_contrato} - ${c.first_name} ${c.last_name}`,
}));


  return (
    <div className="container mt-4 p-4">

      {/* ENCABEZADO */}
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Generar Minuta</h3>
        <button
          className="btn btn-outline-pink"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleGenerate}>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* FILA 1 */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Minuta *</label>
            <select
              name="minuta"
              className="form-select"
              value={formData.minuta}
              onChange={handleChange}
              required
            >
              <option value="" hidden>Seleccione...</option>
              <option value="CONTRATO_FIJO_BUEN_COMIENZO">
                CONTRATO A TERMINO FIJO - BUEN COMIENZO
              </option>
                <option value="OBRA_LABOR_INSTITUCIONAL">
                OBRA LABOR – INSTITUCIONAL
              </option>
              <option value="OBRA_LABOR_HOGARES_SUSTITUTOS">
                OBRA LABOR – HOGARES SUSTITUTOS
              </option>
              <option value="OBRA_LABOR_EXTERNADO_JORNADA_COMPLETA">
                OBRA LABOR – EXTERNADO JORNADA COMPLETA
              </option>
              <option value="CONTRATO_FIJO_INSTITUCION_EDUCATIVA">
                CONTRATO A TERMINO FIJO – INSTITUCIÓN EDUCATIVA
              </option>
              <option value="CONTRATO_FIJO_AREA_ADMINISTRATIVA">
                CONTRATO A TERMINO FIJO – AREA ADMINISTRATIVA
              </option>
              <option value="CONTRATO_INDEFINIDO_AREA_ADMINISTRATIVA">
                CONTRATO TERMINO INDEFINIDO – AREA ADMINISTRATIVA
              </option>
              <option value="CONTRATO_FIJO_HOGARES_SUSTITUTOS">
                CONTRATO TERMINO FIJO – HOGARES SUSTITUTOS
              </option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label>Contrato *</label>
            <SearchSelect
              options={contractOptions}
              value={formData.id_contract}
              placeholder="Buscar contrato por código o nombre..."
              onChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  id_contract: value, // 👈 value YA es el id_contrato
                }))
              }
            />


          </div>
        </div>

        {/* FILA 2 */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Número de contrato *</label>
            <input
              type="text"
              name="numero_contrato"
              className="form-control"
              value={formData.numero_contrato}
              onChange={handleChange}
              required
            />
          </div>


        {/* CAMPO OBJETO - SOLO PARA OBRA LABOR INSTITUCIONAL */}
        {formData.minuta === "OBRA_LABOR_INSTITUCIONAL" && (
            <div className="col-md-6 mb-3">
              <label>Objeto</label>
              <textarea
                name="objeto"
                className="form-control"
                row={3}
                value={formData.objeto}
                onChange={handleChange}
              />
          </div>
        )}

        </div>

        <button type="submit" className="btn btn-outline-pink w-100">
          Generar Minuta
        </button>
      </form>
    </div>
  );
};

export default Minutas;
